import UserNameFormat from "../util/UserNameFormat"
import messageResource from "../messageResource"
import TimeZoneGroupRenderer from "./time_zone_group_renderer"
import TimeZoneGroupController from "./time_zone_group_controller"
import SpinnerController from "../SpinnerController"
import {addClass, removeClass} from "../atBrowserUtils"
import {UserGroupValidatorStrategy, TimeZoneGroupValidatorStrategy} from "../util/GroupValidatorStrategy"
import {TimeZoneGroupManagementController} from "./base_group_management_controller"

const GroupManagementUtil = {}; // namespace

// Constants
GroupManagementUtil.redBorderClassName = "redBorder";
GroupManagementUtil.ellipsisOverflowClassName = "ellipsisOverflow";
GroupManagementUtil.textClassName = "text";


/**
 * Prepare user name to view in interface. Not escaped it.
 * @param user user object from server(converted java BasicUserInfo)
 */
GroupManagementUtil.formatUserName = function(user) {
    var result = UserNameFormat.formatLFM( user.firstName, user.lastName, user.middleInitial );
    if (!user.enabled) {
        result += " ";
        result += messageResource.getMessage("group_management.disable_user");
    }
    return result;
};

/**
 * Mark cell as invalid with red border and append tooltip for it
 * @param cell cell
 * @param title title
 */
GroupManagementUtil.markCellAsInvalid = function(cell, title) {
    addClass(cell, GroupManagementUtil.redBorderClassName);
    cell.title = title;
};

/**
 * Mark cell as valid and remove title
 * @param cell cell
 */
GroupManagementUtil.markCellAsValid = function(cell) {
    removeClass(cell, GroupManagementUtil.redBorderClassName);
    cell.title = "";
};

/**
 * Make id array from array of objects had 'id' property
 * @param objectArray array of objects had 'id' property
 */
GroupManagementUtil.makeIdArrayFromObjectArray = function(objectArray) {
    var idArray = [];
    for (var i = 0; i < objectArray.length; i++) {
        idArray.push(objectArray[i].id);
    }
    return idArray;
};

/**
 * Removes objects with id in specified array from array and returns removed objects.
 * @param idArray array of integers
 * @param sourceArray array for removing. Contains objects with 'id' property.
 * @param exceptIds array of integers. Contains that don't intended for removing.
 */
GroupManagementUtil.removeObjectsFromArrayAndReturnThem = function(idArray, sourceArray, exceptIds) {
    var objectArray = [];
    for (var i = 0; i < idArray.length; i++) {
        for (var j = 0; j < sourceArray.length; j++) {
            if (idArray[i] == sourceArray[j].id) {
                if (!isArrayContains(exceptIds, idArray[i])) {
                    objectArray.push(sourceArray[j]);
                }
                sourceArray.splice(j, 1);
                break;
            }
        }
    }
    return objectArray;
};

/**
 * Create handler on 'Enter' pressed key
 * @param event key down, key up, or key press event
 * @param func function to invoke
 */
GroupManagementUtil.createEnterPressedHandler = function(event, func) {
    event = event || window.event;
    if (event.keyCode == 13) {
        func();
    }
};

/**
 * Create handler on 'Esc' pressed key
 * @param event key down, key up, or key press event
 * @param func function to invoke
 */
GroupManagementUtil.createEscPressedHandler = function(event, func) {
    event = event || window.event;
    if (event.keyCode == 27) {
        func();
    }
};

/**
 * Create handler on no 'Enter' and no 'Esc' pressed key
 * @param event key down, key up, or key press event
 * @param func function to invoke
 */
GroupManagementUtil.createNoEnterAndEscPressedHandler = function(event, func) {
    event = event || window.event;
    if (event.keyCode != 27 && event.keyCode != 13) {
        func();
    }
};

/**
 * Returns element id by DOM element id if DOM element id constructed by {@link formatId()} function
 * @param domId id of an element in DOM
 */
GroupManagementUtil.getElementId = function(domId) {
    return +domId.substr(domId.lastIndexOf("_") + 1);
};

GroupManagementUtil.initializeGroupsLightBox = function(controller, groupRenderer, groupController, addGroupController) {
    var lightboxId = "groupManagementLightBox";
    var getElementBySubId = function(subId) { return document.getElementById(formatId(lightboxId, subId)); };
    var groupNamingKey = "common.user_group";
    var GroupNamingKey = "common.User_Group";

    var groupDivIdPrefix = formatId(lightboxId, "userGroupRow");
    var groupDeleteLinkIdPrefix = formatId(lightboxId, "userGroupDeleteLink");
    var deleteGroupUndoButtonIdPrefix = formatId(lightboxId, "confirmDeleteUndoButton");
    var deleteGroupAcceptButtonIdPrefix = formatId(lightboxId, "confirmDeleteAcceptButton");
    var editGroupUndoButtonIdPrefix = formatId(lightboxId, "editUserGroupUndoButton");
    var editGroupAcceptButtonIdPrefix = formatId(lightboxId, "editUserGroupAcceptButton");
    var editGroupInputIdPrefix = formatId(lightboxId, "editUserGroupInput");
    var groupNameCellIdPrefix = formatId(lightboxId, "userGroupNameCell");
    var groupEditInputCellIdPrefix = formatId(lightboxId, "userGroupEditInputCell");
    var groupEditTableCellIdPrefix = formatId(lightboxId, "userGroupEditTableCell");
    var groupWaitingAnimationCellIdPrefix = formatId(lightboxId, "userGroupWaitingAnimationCell");
    var groupSpinnerContainerIdPrefix = formatId(lightboxId, "groupSpinnerContainer");

    var userDivIdPrefix = formatId(lightboxId, "userDiv");
    var userCheckboxIdPrefix = formatId(lightboxId, "userCheckbox");

    var ajaxProcessingClassName = "ajaxProcessing";

    var groupContainer = getElementBySubId("groupContainer");
    var userContainer = getElementBySubId("userContainer");
    var addGroupContainer = getElementBySubId('addGroupContainer');
    var userContainerWrapper = getElementBySubId("userContainerWrapper");
    var validatorGroupStrategy = new UserGroupValidatorStrategy();
    var emptyGroupMessageTable = getElementBySubId("emptyGroupMessageTable");
    var emptyGroupResolver = new EmptyGroupResolver(
            emptyGroupMessageTable,
            emptyGroupMessageTable.getElementsByTagName("td")[0],
            userContainerWrapper,
            {
                groupNamingKey:groupNamingKey,
                GroupNamingKey : GroupNamingKey,
                validatorGroupStrategy: validatorGroupStrategy
            });

    var addGroupTableId = formatId(lightboxId, 'addGroupRow');
    var addGroupInputId = formatId(lightboxId, 'newGroupInput');
    var addGroupButtonId = formatId(lightboxId, 'addGroupButton');
    var addGroupSpinnerId = formatId(lightboxId, 'addNewGroupWaitingAnimationCell');

    var spinnerController = GroupManagementUtil.createSpinnerControllerForGroupsLightbox();

    groupRenderer.init({
        groupDivClassName: "userGroupDiv",
        groupTableClassName: "entityTable",
        folderImgClassName: "folderImageCell",
        deleteGroupLinkClassName: "deleteGroupCell",
        groupNameCellClassName: "groupNameCell",
        counterSpanClassName: "counterCell",
        waitingAnimationCellClassName: "waitingAnimationCell",
        editTableCellClassName: "editGroupTableCell",
        editInputClassName: "editGroupInput",
        undoButtonClassName: "undoEdit",
        acceptButtonClassName: "acceptEdit",
        nullGroupClassName: "nullGroup",
        confirmDeleteCellClassName: "confirmDeleteGroupCell",
        confirmDeleteAcceptButtonClassName: "confirmDeleteGroupButton",
        confirmDeleteUndoButtonClassName: "cancelDeleteGroupButton",
        groupDivIdPrefix: groupDivIdPrefix,
        deleteLinkIdPrefix: groupDeleteLinkIdPrefix,
        undoEditIdPrefix: editGroupUndoButtonIdPrefix,
        acceptEditIdPrefix: editGroupAcceptButtonIdPrefix,
        editInputIdPrefix: editGroupInputIdPrefix,
        nameCellIdPrefix: groupNameCellIdPrefix,
        inputCellIdPrefix: groupEditInputCellIdPrefix,
        editGroupCellIdPrefix: groupEditTableCellIdPrefix,
        waitingAnimationCellIdPrefix: groupWaitingAnimationCellIdPrefix,
        spinnerContainerIdPrefix: groupSpinnerContainerIdPrefix,
        confirmDeleteCellIdPrefix: formatId(lightboxId, "confirmDeleteGroupId"),
        confirmDeleteAcceptButtonIdPrefix: deleteGroupAcceptButtonIdPrefix,
        confirmDeleteUndoButtonIdPrefix: deleteGroupUndoButtonIdPrefix,
        groupNamingKey: groupNamingKey,
        GroupNamingKey: GroupNamingKey,
        validatorGroupStrategy: validatorGroupStrategy
    });

    var userRenderer = new UserRenderer(
            "userDiv", "entityTable", "dragImageCell", "usernameCell", "grayedText", "checkboxCell", userDivIdPrefix, userCheckboxIdPrefix
    );

    var ddController = new DragAndDropController(
            "groupManagementLightBox_ddProxy",
            "groupManagementLightBox_ddProxyRow",
            "currentlyDraggedUserDiv",
            "undroppable",
            groupNamingKey
    );

    groupController.init({
        topGroupNameLabel: getElementBySubId("topGroupNameLabel"),
        deletedNowGroupClassName: ajaxProcessingClassName + " deletedNow",
        editedNowGroupClassName: ajaxProcessingClassName + " editedNow",
        movedInNowGroupClassName: ajaxProcessingClassName,
        editedClassName: "editedGroup",
        confirmDeleteClassName: "deleteConfirm",
        errorTextClassName: "errorText",
        groupDivIdPrefix: groupDivIdPrefix,
        groupDeleteLinkIdPrefix: groupDeleteLinkIdPrefix,
        undoDeleteIdPrefix: deleteGroupUndoButtonIdPrefix,
        acceptDeleteIdPrefix: deleteGroupAcceptButtonIdPrefix,
        undoEditIdPrefix: editGroupUndoButtonIdPrefix,
        acceptEditIdPrefix: editGroupAcceptButtonIdPrefix,
        editInputIdPrefix: editGroupInputIdPrefix,
        nameCellIdPrefix: groupNameCellIdPrefix,
        inputCellIdPrefix: groupEditInputCellIdPrefix,
        editGroupCellIdPrefix: groupEditTableCellIdPrefix,
        waitingAnimationCellIdPrefix: groupWaitingAnimationCellIdPrefix,
        spinnerContainerIdPrefix: groupSpinnerContainerIdPrefix,
        spinnerController: spinnerController,
        groupNamingKey: groupNamingKey,
        GroupNamingKey: GroupNamingKey
    });

    var userController = new UserController(userDivIdPrefix, userCheckboxIdPrefix, "selectedUser");

    var addGroupRenderer = new AddUserGroupRenderer().init(
            {
                addGroupTableId: addGroupTableId,
                inputId: addGroupInputId,
                buttonId: addGroupButtonId,
                spinnerId: addGroupSpinnerId,
                imageCellClassName: 'addImageCell',
                inputCellClassName: 'newGroupInputCell',
                buttonCellClassName: 'addGroupButtonCell',
                spinnerCellClassName: 'waitingAnimationCell'
            }
    );

    addGroupController.init(
            {
                newGroupInputId: addGroupInputId,
                newGroupInputCellId: formatId(lightboxId, 'addGroupContainer'),
                addGroupButtonId: addGroupButtonId,
                addGroupRowId: addGroupTableId,
                rowHighlightedClassName: "rowHighlighted",
                ajaxProcessingClassName: ajaxProcessingClassName,
                waitingAnimationCellId: addGroupSpinnerId,
                groupNamingKey: groupNamingKey,
                GroupNamingKey: GroupNamingKey,
                spinnerController: spinnerController
            }
    );

    var highlightController = new HighlightController("selectedUserGroupDiv", "userGroupDivHover", "groupButtonControlHover", "hoverUndoAcceptEditButton");

    var commonRenderer = new CommonRenderer(groupRenderer, userRenderer, addGroupRenderer, groupContainer,
                                            userContainer, addGroupContainer, formatId(lightboxId, "moveToMenu"));

    var showDisabledUsersCheckbox = getElementBySubId("showDisabledUsersCheckbox");
    var dataLoadingSpinnerContainerId = formatId(lightboxId, "dataLoadingSpinnerContainer");

    return controller.init(commonRenderer, groupController, userController, ddController,
            addGroupController, highlightController, emptyGroupResolver, groupContainer,
            getElementBySubId("selectAllButtonImg"), getElementBySubId("clearSelectionButtonImg"), getElementBySubId("filterSelectionButtonImg"),
            showDisabledUsersCheckbox, getElementBySubId("showDisabledUsersLabel"),
            getElementBySubId("errorMessagesRow"), getElementBySubId("bottomErrorMessageText"),
            document.getElementById(lightboxId), "ajaxIsNow", "dragAndDropIsNow", "UserGroupManagementService",
            GroupNamingKey, spinnerController, dataLoadingSpinnerContainerId, "dataLoading", validatorGroupStrategy
    );
};

GroupManagementUtil.initializeTimeZoneGroupsLightBox = function() {
    var groupNamingKey = "common.time_zone_group";
    var GroupNamingKey = "common.Time_Zone_Group";
    var lightboxId = "timeZoneGroupManagementLightBox";
    var getElementBySubId = function(subId) { return document.getElementById(formatId(lightboxId, subId)); };

    var groupDivIdPrefix = formatId(lightboxId, "userGroupRow");
    var groupDeleteLinkIdPrefix = formatId(lightboxId, "userGroupDeleteLink");
    var deleteGroupUndoButtonIdPrefix = formatId(lightboxId, "confirmDeleteUndoButton");
    var deleteGroupAcceptButtonIdPrefix = formatId(lightboxId, "confirmDeleteAcceptButton");
    var editGroupUndoButtonIdPrefix = formatId(lightboxId, "editUserGroupUndoButton");
    var editGroupAcceptButtonIdPrefix = formatId(lightboxId, "editUserGroupAcceptButton");
    var editGroupInputIdPrefix = formatId(lightboxId, "editUserGroupInput");
    var groupNameCellIdPrefix = formatId(lightboxId, "userGroupNameCell");
    var groupEditInputCellIdPrefix = formatId(lightboxId, "userGroupEditInputCell");
    var groupEditTableCellIdPrefix = formatId(lightboxId, "userGroupEditTableCell");
    var groupWaitingAnimationCellIdPrefix = formatId(lightboxId, "userGroupWaitingAnimationCell");
    var groupSpinnerContainerIdPrefix = formatId(lightboxId, "groupSpinnerContainer");
    var groupSelectorIdPrefix = formatId(lightboxId, 'groupCitySelector');
    var groupCurrentTimeIdPrefix = formatId(lightboxId, 'groupCurrentTime');

    var userDivIdPrefix = formatId(lightboxId, "userDiv");
    var userCheckboxIdPrefix = formatId(lightboxId, "userCheckbox");

    var ajaxProcessingClassName = "ajaxProcessing";

    var groupContainer = getElementBySubId("groupContainer");
    var userContainer = getElementBySubId("userContainer");
    var addGroupContainer = getElementBySubId('addGroupContainer');
    var userContainerWrapper = getElementBySubId("userContainerWrapper");
    var validatorGroupStrategy = new TimeZoneGroupValidatorStrategy();
    var emptyGroupMessageTable = getElementBySubId("emptyGroupMessageTable");
    var emptyGroupResolver = new EmptyGroupResolver(emptyGroupMessageTable,
            emptyGroupMessageTable.getElementsByTagName("td")[0],
            userContainerWrapper,
            {
                groupNamingKey:groupNamingKey,
                GroupNamingKey : GroupNamingKey,
                validatorGroupStrategy: validatorGroupStrategy
            });

    var addGroupTableId = formatId(lightboxId, 'addGroupRow');
    var addGroupInputId = formatId(lightboxId, 'newGroupInput');
    var addGroupButtonId = formatId(lightboxId, 'addGroupButton');
    var addGroupSpinnerId = formatId(lightboxId, 'addNewGroupWaitingAnimationCell');
    var addGroupSelectorId = formatId(lightboxId, 'addGroupSelectorId');

    var spinnerController = GroupManagementUtil.createSpinnerControllerForGroupsLightbox();
    var groupRenderer = new TimeZoneGroupRenderer().init(
            {
                groupDivClassName: "userGroupDiv",
                groupTableClassName: "entityTable",
                folderImgClassName: "folderImageCell",
                deleteGroupLinkClassName: "deleteGroupCell",
                groupNameCellClassName: "groupNameCell",
                counterSpanClassName: "counterCell",
                waitingAnimationCellClassName: "waitingAnimationCell",
                editTableCellClassName: "editGroupTableCell",
                editInputClassName: "editGroupInput",
                undoButtonClassName: "undoEdit",
                acceptButtonClassName: "acceptEdit",
                defaultGroupClassName: "defaultGroup",
                confirmDeleteCellClassName: "confirmDeleteGroupCell",
                confirmDeleteAcceptButtonClassName: "confirmDeleteGroupButton",
                confirmDeleteUndoButtonClassName: "cancelDeleteGroupButton",
                selectorCellClassName: 'selectorCell',
                secondRowClassName: 'secondRow',
                defaultGroupLabelCellClassName: 'defaultGroupLabelCell',
                currentTimeCellClassName: 'currentTimeCell',
                groupDivIdPrefix: groupDivIdPrefix,
                deleteLinkIdPrefix: groupDeleteLinkIdPrefix,
                undoEditIdPrefix: editGroupUndoButtonIdPrefix,
                acceptEditIdPrefix: editGroupAcceptButtonIdPrefix,
                editInputIdPrefix: editGroupInputIdPrefix,
                nameCellIdPrefix: groupNameCellIdPrefix,
                inputCellIdPrefix: groupEditInputCellIdPrefix,
                editGroupCellIdPrefix: groupEditTableCellIdPrefix,
                waitingAnimationCellIdPrefix: groupWaitingAnimationCellIdPrefix,
                spinnerContainerIdPrefix: groupSpinnerContainerIdPrefix,
                confirmDeleteCellIdPrefix: formatId(lightboxId, "confirmDeleteGroupId"),
                confirmDeleteAcceptButtonIdPrefix: deleteGroupAcceptButtonIdPrefix,
                confirmDeleteUndoButtonIdPrefix: deleteGroupUndoButtonIdPrefix,
                selectorIdPrefix: groupSelectorIdPrefix,
                currentTimeIdPrefix: groupCurrentTimeIdPrefix,
                groupNamingKey:groupNamingKey,
                GroupNamingKey : GroupNamingKey,
                validatorGroupStrategy: validatorGroupStrategy
            }
    );

    var userRenderer = new UserRenderer(
            "userDiv", "entityTable", "dragImageCell", "usernameCell", "grayedText", "checkboxCell", userDivIdPrefix, userCheckboxIdPrefix
    );

    var ddController = new DragAndDropController("groupManagementLightBox_ddProxy", "groupManagementLightBox_ddProxyRow", "currentlyDraggedUserDiv", "undroppable", groupNamingKey);

    var groupController = new TimeZoneGroupController().init(
            {
                topGroupNameLabel: getElementBySubId("topGroupNameLabel"),
                deletedNowGroupClassName: ajaxProcessingClassName + " deletedNow",
                editedNowGroupClassName: ajaxProcessingClassName + " editedNow",
                movedInNowGroupClassName: ajaxProcessingClassName,
                editedClassName: "editedGroup",
                confirmDeleteClassName: "deleteConfirm",
                errorTextClassName: "errorText",
                groupDivIdPrefix: groupDivIdPrefix,
                groupDeleteLinkIdPrefix: groupDeleteLinkIdPrefix,
                undoDeleteIdPrefix: deleteGroupUndoButtonIdPrefix,
                acceptDeleteIdPrefix: deleteGroupAcceptButtonIdPrefix,
                undoEditIdPrefix: editGroupUndoButtonIdPrefix,
                acceptEditIdPrefix: editGroupAcceptButtonIdPrefix,
                editInputIdPrefix: editGroupInputIdPrefix,
                nameCellIdPrefix: groupNameCellIdPrefix,
                inputCellIdPrefix: groupEditInputCellIdPrefix,
                editGroupCellIdPrefix: groupEditTableCellIdPrefix,
                waitingAnimationCellIdPrefix: groupWaitingAnimationCellIdPrefix,
                spinnerContainerIdPrefix: groupSpinnerContainerIdPrefix,
                selectorIdPrefix: groupSelectorIdPrefix,
                spinnerController: spinnerController,
                currentTimeIdPrefix: groupCurrentTimeIdPrefix,
                groupNamingKey:groupNamingKey,
                GroupNamingKey : GroupNamingKey
            }
    );

    var userController = new UserController(userDivIdPrefix, userCheckboxIdPrefix, "selectedUser");

    var addGroupRenderer = new AddTimeZoneGroupRenderer().init(
            {
                addGroupTableId: addGroupTableId,
                inputId: addGroupInputId,
                buttonId: addGroupButtonId,
                spinnerId: addGroupSpinnerId,
                selectorId: addGroupSelectorId,
                imageCellClassName: 'addImageCell',
                inputCellClassName: 'newGroupInputCell',
                buttonCellClassName: 'addGroupButtonCell',
                spinnerCellClassName: 'waitingAnimationCell',
                selectorCellClassName: 'selectorCell',
                timeZoneImageCellClassName: 'timeZoneImageCell',
                groupNamingKey:groupNamingKey,
                GroupNamingKey : GroupNamingKey
            }
    );

    var addGroupController = new AddTimeZoneGroupController().init(
            {
                newGroupInputId: addGroupInputId,
                newGroupInputCellId: formatId(lightboxId, 'addGroupContainer'),
                addGroupButtonId: addGroupButtonId,
                addGroupRowId: addGroupTableId,
                addGroupSelectorId: addGroupSelectorId,
                rowHighlightedClassName: "rowHighlighted",
                ajaxProcessingClassName: ajaxProcessingClassName,
                waitingAnimationCellId: addGroupSpinnerId,
                editStateClassName: 'editState',
                groupNamingKey:groupNamingKey,
                GroupNamingKey : GroupNamingKey,
                spinnerController: spinnerController
            }
    );

    var highlightController = new HighlightController("selectedUserGroupDiv", "userGroupDivHover", "groupButtonControlHover", "hoverUndoAcceptEditButton");

    var commonRenderer = new CommonRenderer(groupRenderer, userRenderer, addGroupRenderer, groupContainer,
                                            userContainer, addGroupContainer, formatId(lightboxId, "moveToMenu"));

    var showDisabledUsersCheckbox = getElementBySubId("showDisabledUsersCheckbox");
    var dataLoadingSpinnerContainerId = formatId(lightboxId, "dataLoadingSpinnerContainer");

    return new TimeZoneGroupManagementController().init(commonRenderer, groupController, userController, ddController,
                                                        addGroupController, highlightController, emptyGroupResolver, groupContainer,
                                                        getElementBySubId("selectAllButtonImg"), getElementBySubId("clearSelectionButtonImg"), getElementBySubId("filterSelectionButtonImg"),
                                                        showDisabledUsersCheckbox, getElementBySubId("showDisabledUsersLabel"),
                                                        getElementBySubId("errorMessagesRow"), getElementBySubId("bottomErrorMessageText"),
                                                        document.getElementById(lightboxId), "ajaxIsNow", "dragAndDropIsNow", "TimeZoneGroupManagementService",
                                                        GroupNamingKey, spinnerController, dataLoadingSpinnerContainerId, "dataLoading",validatorGroupStrategy,
                                                        "onlyOneGroup");

};

GroupManagementUtil.createSpinnerControllerForGroupsLightbox = function()
{
    var spinnerOptions = {
        lines: 11, // The number of lines to draw
        length: 6, // The length of each line
        width: 2, // The line thickness
        radius: 5, // The radius of the inner circle
        corners: 1, // Corner roundness (0..1)
        rotate: 0, // The rotation offset
        direction: 1, // 1: clockwise, -1: counterclockwise
        color: '#bbbbbb', // #rgb or #rrggbb
        speed: 1, // Rounds per second
        trail: 60, // Afterglow percentage
        shadow: false, // Whether to render a shadow
        hwaccel: false, // Whether to use hardware acceleration
        className: 'spinner', // The CSS class to assign to the spinner
        zIndex: 2e9, // The z-index (defaults to 2000000000)
        top: 'auto', // Top position relative to parent in px
        left: 'auto' // Left position relative to parent in px
    };
    var spinner = new Spinner(spinnerOptions);
    var spinnerController = new SpinnerController(true);
    spinnerController.setSpinner(spinner);
    return spinnerController;
};

export default GroupManagementUtil;


// WEBPACK FOOTER //
// ./web/js/groupManagement/group_management_util.js